import { Button, Modal } from 'antd';
import Adjustments from './Adjustments';
const AdjustmentModal = ({
  project,
  hideModal,
  isVisible
}) => {
  const handleClose = () => {
    hideModal();
  };
  return <Modal title={`Project ${project?.id} Adjustments`} visible={isVisible} width={800} footer={[<Button key="close" type="primary" onClick={handleClose} data-testid="Adjustments-close-button">
          Close
        </Button>]}>
      <Adjustments project={project} />
    </Modal>;
};
export default AdjustmentModal;